import { RTable } from "../../Component/Table/RTable";
import { TableStructure } from "../../Component/Table/TableStructureInterface";
import { formInterface } from "../../Component/GenericForm/formInterface";
import { PageHeader } from "../../Component/Common/Headers";
import { dateFormat } from "../../Helpers/commonFunction/commonFunction";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../Helpers/config/config";

export const UniversityList = () => {
    const tableStructure: TableStructure[] = [
        {
            name: "id", render: (data: any, index: any) => {
                return index;
            },
        },
        {
            name: "Name", render: (data: any, index: any) => {
                return `${data.name}`;
            },
        },
        { name: "Slug", key: "slug" },
        { name: "Type", key: "type" },
        { name: "State", key: "state" },
        { name: "City", key: "city" },
        { name: "Ranking", key: "ranking" },
        {
            name: "CreatedAt", render: (data: any, index: any) => {
                return dateFormat(data.createdAt);
            }
        },

        {
            name: "Action", render: (data: any, onDelete: any) => {
                return <div className="d-flex align-items-center justify-content-start gap-3">
                    <Link to={`/UniversityForm/${data.id}`}>
                        <img width="16px" src={PUBLIC_URL + "/images/edit.svg"} alt="edit" />
                    </Link>
                    <Link to="#" onClick={() => { onDelete(data.id) }}>
                        <img width="16px" src={PUBLIC_URL + "/images/delete.svg"} alt="delete" />
                    </Link>
                </div>;
            },
        },
    ];

    return (
        <div className="container">
            <PageHeader
                title="University Management"
                subtitle="Configure universities"
            />
            <RTable xFileName="university_data" Addlink="/UniversityForm" deleteUrl="universities" api="universities/withPagination" tableStructure={tableStructure} />
        </div>
    );
};
